/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SystemMenuPropsData = {
    readonly currentUser: {
        readonly menuItems: {
            readonly config: {
                readonly icon: string | null;
            };
        };
        readonly name: string;
    };
    readonly " $refType": "SystemMenuPropsData";
};
export type SystemMenuPropsData$data = SystemMenuPropsData;
export type SystemMenuPropsData$key = {
    readonly " $data"?: SystemMenuPropsData$data;
    readonly " $fragmentRefs": FragmentRefs<"SystemMenuPropsData">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SystemMenuPropsData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthenticatedUser",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MenuView",
          "kind": "LinkedField",
          "name": "menuItems",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MenuItem",
              "kind": "LinkedField",
              "name": "config",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "icon",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = '9904585d5d22b49491fe2c7d5bb0c7cd';
export default node;
